import {onFind} from "@elements/init-modules-in-scope";
import {hasClass, on, off, findAllIn, closest} from '@elements/dom-utils';

const selectors = {
    base: '.js-move-row',
    row: '.js-move-row__row',
    btn: '.js-move-row__btns',
};

export function init() {
    onFind(selectors.btn, function (btn) {
        const clickButton = function () {
            let row = closest(selectors.row, btn);
            moveRow(row, btn)
        }
        
        on("click", clickButton , btn);

        return {
            cleanUp: () => {
                off("click", clickButton , btn);
            }
        };

    });
}

function moveRow(row, btn) {
    if (btn.getAttribute("data-button") == "up"){
        let table = row.parentNode;
        let prevSpacer = row.previousElementSibling;
        let prevRow = row.previousElementSibling.previousElementSibling;

        if (!hasClass("cockpit-table__row--head", prevSpacer) && prevRow){
            table.insertBefore ( row , prevRow ); //move row above prev row
            table.insertBefore ( prevSpacer , prevRow ); //move spacer above prev row
        }
    }else{
        let table = row.parentNode;
        let currentSpacer = row.nextElementSibling; //spacer where the row is

        //if the spacer is not the last spacer
        if (table.rows[ table.rows.length - 1 ] !== currentSpacer){
            let nextSpacer = row.nextElementSibling.nextElementSibling.nextElementSibling; //spacer where to move the row

            table.insertBefore ( row , nextSpacer ); //move row above next spacer
            table.insertBefore ( currentSpacer , row ); //move spacer above row
        }
    }
}
